import React from "react";
import clsx from "clsx";
import s from "./TableRow.less";

interface IProps {
  options: string[];
  optionChildren: string[];
  styleRow?: boolean;
  item;
}

const GRTableRow: React.FC<IProps> = ({
  options = [],
  optionChildren = [],
  item = {},
  styleRow = false,
}) => {
  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td
            className={clsx({
              [s.style_back]: styleRow === true && !item.ParentId,
              [s.style_last_row]: item.typeName === "total",
              [s.deleted_gr]:
                optionName !== "number" && item[optionName] === undefined,

              [s.red]:
                optionName === "IndicatorQuarter1_2"
                  ? item.IndicatorQuarter1_2 < 0
                  : optionName === "IndicatorQuarter2_3"
                  ? item.IndicatorQuarter2_3 < 0
                  : optionName === "IndicatorQuarter3_4"
                  ? item.IndicatorQuarter3_4 < 0
                  : false,

              [s.green]:
                optionName === "IndicatorQuarter1_2"
                  ? item.IndicatorQuarter1_2 > 0
                  : optionName === "IndicatorQuarter2_3"
                  ? item.IndicatorQuarter2_3 > 0
                  : optionName === "IndicatorQuarter3_4"
                  ? item.IndicatorQuarter3_4 > 0
                  : false,

              [s.loft]:
                styleRow && (item.number === "" || item.number === null)
                  ? optionName === "IndicatorQuarter1_2"
                    ? item.IndicatorQuarter1_2 < 0
                    : optionName === "IndicatorQuarter2_3"
                    ? item.IndicatorQuarter2_3 < 0
                    : optionName === "IndicatorQuarter3_4"
                    ? item.IndicatorQuarter3_4 < 0
                    : false
                  : false,

              [s.loft_green]:
                styleRow && (item.number === "" || item.number === null)
                  ? optionName === "IndicatorQuarter1_2"
                    ? item.IndicatorQuarter1_2 > 0
                    : optionName === "IndicatorQuarter2_3"
                    ? item.IndicatorQuarter2_3 > 0
                    : optionName === "IndicatorQuarter3_4"
                    ? item.IndicatorQuarter3_4 > 0
                    : false
                  : false,
            })}
            key={optionName}
            data-option_name={optionName}
          >
            <div>
              {optionChildren.length > 0 &&
                optionChildren.includes(optionName) && (
                  <div className={s.NoActual}>
                    {item[optionName + "NoActual"]}
                  </div>
                )}
              {item[optionName]}
            </div>
          </td>
        ))}
      </tr>
    </>
  );
};
export default GRTableRow;
